import { Field } from "react-final-form";
import BMXAsynchronous from "../../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import BMXSelectField from "../../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import { Col, Row } from "react-bootstrap";
import { Icon, IconButton } from "@mui/material";
import store from "../../../../../../store";
import { show } from "redux-modal";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { useDispatch } from "react-redux";
const ServiceDeviceSelector = ({
  t,
  values,
  options,
  serviceBaseSelect,
  getDevices,
  setSelectedDevice,
  fetchLastServices,
  form,
  update,
  props,
}) => {

  const dispatch  = useDispatch();

  return (
    <Row
      style={{
        display: "inline-flex",
        alignContent: "center",
        alignItems: "center",
      }}
    >
      <Col
        xs={6}
        style={{
          display: "inline-flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: "5px",
        }}
      >
        <Icon
          style={{ fontSize: "20px", paddingBottom: "30px" }}
          className="primary text"
        >
          print
        </Icon>

        <Field
          style={{ width: "100%", maxWidth: "260px" }}
          currentValues={values}
          className="step-one-device-select"
          component={BMXAsynchronous}
          label={`${t("global:service.device")}`}
          name="device"
          disabled={update}
          options={options}
          getData={getDevices}
          getOptionLabel={(option) => option?.serialNumber?.trim() || option}
          disablePortal
          data-cy="device"
          onChange={(device) => {
            if (!device) {
              setSelectedDevice(null);
              form.change("serviceBase", null);
              return;
            }

            setSelectedDevice(device);
            fetchLastServices(device.serialNumber);

            if (device?.serviceBase) {
              form.change("serviceBase", {
                ...device.serviceBase,
                name: device.serviceBase.entryName,
                value: device.serviceBase.uuid,
              });
            }
          }}
        />
        <IconButton
          style={{
            padding: "0",
          }}
          onClick={() =>
            dispatch(
              show("DeviceModal", {
                ...props,
                // updateTableRegistry,
                header: t("global:devices.add"),
                // loadData,
              }),
            )
          }
        >
          <Icon style={{ fontSize: "20px" }} className="dark-grey text">
            add
          </Icon>
        </IconButton>
      </Col>

      <Col xs={6}>
        <Field
          style={{ width: "100%", maxWidth: "260px" }}
          component={BMXSelectField}
          values={serviceBaseSelect}
          name="serviceBase"
          readOnly
          label={`${t("global:service.serviceBase")}`}
          data-cy="serviceBase"
        />
      </Col>
    </Row>
  );
};

export default ServiceDeviceSelector;
